"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicHandler = {
    filter: function (value) {
        return value;
    },
    parse: function (value) {
        return value;
    },
    format: function (value) {
        return value;
    },
    validate: function (value) {
        return true;
    }
};
exports.numberHandler = {
    filter: function (value) {
        return value.match("[0-9\.-]*")[0];
    },
    parse: function (value) {
        var floatValue = parseFloat(value);
        return !isNaN(floatValue) ? floatValue : null;
    },
    format: function (value) {
        return value + '';
    },
    validate: function (value) {
        return !isNaN(value);
    }
};
exports.fileHandler = __assign(__assign({}, exports.basicHandler), { parse: function (files) {
        return files.length == 1 ? files[0] : files;
    } });
